module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quill-editor"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbf53ac0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-quill/src/Quill.vue
// module id = 268
// module chunks = 1